import { Link, useSearchParams } from "react-router-dom";
import style from "./TabsNavigate.module.scss";
import cn from "classnames";

export function TabsNavigate() {
    const [queryParams] = useSearchParams();

    return (
        <div className={style.container}>
            <p className={style.pageName}>Поповнити баланс</p>
            <div className={style.tabsButtons}> 
                <Link
                    className={cn(style.button, queryParams.get("tab") === "replenish" && style.button_active)}
                    to={".?tab=replenish"}
                >
                    Поповнення балансу
                </Link>
                <Link
                    className={cn(style.button, queryParams.get("tab") === "history" && style.button_active)}
                    to={".?tab=history"}
                > 
                    Історія балансу
                </Link>
            </div>
        </div>
    )
}